import DnerhsApi from "api/DnerhsApi";

const URL_BASE_DATOS_PERSONALES = "/datos-personales/";
const URL_BASE_DATOS_PERSONALES_NAC = "/datos-personales-cedula-fn/";

const findByNumeroCedula = async (numeroCedula) => {
    return DnerhsApi.get(`${URL_BASE_DATOS_PERSONALES}${numeroCedula}`);
};
const findByNumeroCedulaFechaNac = async (numeroCedula, fechaNac) => {
    return DnerhsApi.get(`${URL_BASE_DATOS_PERSONALES_NAC}${numeroCedula}/${fechaNac}`);
};
export {
    findByNumeroCedula,
    findByNumeroCedulaFechaNac
};
